export const FETCH_UNDER_CONSTRUCTION_PAGE = "fetchUnderConstructionPage";
